import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

const CustomDatePicker = (props) => {
    const years = [];
    const currentYear = new Date().getFullYear();
    for (let i = currentYear - 10; i <= currentYear + 10; i++) {
        years.push(i);
    }
    const months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

    return (
        <DatePicker
            {...props}
            renderCustomHeader={({
                date,
                changeYear,
                changeMonth,
                decreaseMonth,
                increaseMonth,
                prevMonthButtonDisabled,
                nextMonthButtonDisabled,
            }) => (
                <div
                    style={{
                        margin: 10,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <button
                        type="button"
                        className="react-datepicker__navigation react-datepicker__navigation--previous"
                        onClick={decreaseMonth}
                        disabled={prevMonthButtonDisabled}
                        style={{ position: 'relative', top: 0, left: 0, marginRight: '10px' }}
                    >
                        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous"></span>
                    </button>

                    <select
                        value={date.getMonth()}
                        onChange={({ target: { value } }) => changeMonth(value)}
                        className="react-datepicker__month-select"
                        style={{ marginRight: '5px' }}
                    >
                        {months.map((option) => (
                            <option key={option} value={option}>
                                Tháng {option + 1}
                            </option>
                        ))}
                    </select>

                    <select
                        value={date.getFullYear()}
                        onChange={({ target: { value } }) => changeYear(value)}
                        className="react-datepicker__year-select"
                    >
                        {years.map((option) => (
                            <option key={option} value={option}>
                                Năm {option}
                            </option>
                        ))}
                    </select>

                    <button
                        type="button"
                        className="react-datepicker__navigation react-datepicker__navigation--next"
                        onClick={increaseMonth}
                        disabled={nextMonthButtonDisabled}
                        style={{ position: 'relative', top: 0, right: 0, marginLeft: '10px' }}
                    >
                        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next"></span>
                    </button>
                </div>
            )}
        />
    );
};

export default CustomDatePicker;
